<template>
  <el-aside class="index-aside" width="200px">
    <div class="index-aside-inner menulist">
      <div
        v-for="item in menuList"
        :key="item.roleName"
        v-if="role === item.roleName"
        class="menulist-item"
      >
        <el-menu
          :default-active="$route.path"
          class="el-menu-vertical-demo"
          :unique-opened="true"
          router
         
          active-text-color="rgb(28 66 83)"
        >
          <!-- 首页 -->
          <el-menu-item index="/index">
            <i class="el-icon-s-home"></i>
            <span>{{ $t('nav.home') }}</span>
          </el-menu-item>

          <!-- 个人中心示例 -->
          <el-submenu index="1">
            <template #title>
              <i class="el-icon-user-solid"></i>
              <span>{{ $t('nav.personalCenter') }}</span>
            </template>
            <el-menu-item index="/updatePassword">{{ $t('nav.changePassword') }}</el-menu-item>
            <el-menu-item index="/center">{{ $t('nav.personalInfo') }}</el-menu-item>
          </el-submenu>

          <!-- 后台配置菜单 -->
          <el-submenu
            v-for="(m, i) in item.backMenu"
            :key="m.menu"
            :index="(i + 2).toString()"
          >
            <template #title>
              <i :class="icons[i]"></i>
              <span>{{ getMenuTranslation(m.menu) }}</span>
            </template>
            <el-menu-item
              v-for="(child, j) in m.child"
              :key="j"
              :index="'/' + child.tableName"
              :class="{ 'menu-disabled': isMenuDisabled(child.menu) }"
              @click.native="handleMenuClick(child)"
            >
              {{ getMenuTranslation(child.menu) }}
            </el-menu-item>
          </el-submenu>
        </el-menu>
      </div>
    </div>
  </el-aside>
</template>
<script>
import menu from '@/utils/menu'
export default {
  data() {
    return {
      menuList: [],
      dynamicMenuRoutes: [],
      role: '',
      icons: [
        'el-icon-s-cooperation',
        'el-icon-s-order',
        'el-icon-s-platform',
        'el-icon-s-fold',
        'el-icon-s-unfold',
        'el-icon-s-operation',
        'el-icon-s-promotion',
        'el-icon-s-release',
        'el-icon-s-ticket',
        'el-icon-s-management',
        'el-icon-s-open',
        'el-icon-s-shop',
        'el-icon-s-marketing',
        'el-icon-s-flag',
        'el-icon-s-comment',
        'el-icon-s-finance',
        'el-icon-s-claim',
        'el-icon-s-custom',
        'el-icon-s-opportunity',
        'el-icon-s-data',
        'el-icon-s-check',
        'el-icon-s-grid',
        'el-icon-menu',
        'el-icon-chat-dot-square',
        'el-icon-message',
        'el-icon-postcard',
        'el-icon-position',
        'el-icon-microphone',
        'el-icon-close-notification',
        'el-icon-bangzhu',
        'el-icon-time',
        'el-icon-odometer',
        'el-icon-crop',
        'el-icon-aim',
        'el-icon-switch-button',
        'el-icon-full-screen',
        'el-icon-copy-document',
        'el-icon-mic',
        'el-icon-stopwatch',
      ],
      menulistStyle: '${template.back.menulist.menulistStyle}',
	  menulistBorderBottom: {},
    }
  },
  mounted() {
    const menus = menu.list()
    if(menus) {
        this.menuList = menus
    } else {
        let params = {
            page: 1,
            limit: 1,
            sort: 'id',
        }
        this.$http({
            url: "menu/list",
            method: "get",
            params: params
        }).then(({
            data
        }) => {
            if (data && data.code === 0) {
                this.menuList = JSON.parse(data.data.list[0].menujson);
                this.$storage.set("menus", this.menuList);
            }
        })
    }
    this.role = this.$storage.get('role')
  },
  created(){
   
  },
  methods: {
	
    menuHandler(name) {
      let router = this.$router
      name = '/'+name
      router.push(name)
    },
    // 菜单翻译映射
    getMenuTranslation(menuName) {
      const menuMap = {
        '教练预约管理': 'menu.coachAppointmentMgmt',
        '教练预约': 'menu.coachAppointment',
        '用户管理': 'menu.userMgmt',
        '用户': 'menu.user',
        'VIP用户': 'menu.vipUser',
        '教练管理': 'menu.coachMgmt',
        '教练': 'menu.coach',
        '教练排班': 'menu.coachScheduling',
        '设置教练空闲时间': 'menu.setCoachFreeTime',
        '健身项目管理': 'menu.fitnessProjectMgmt',
        '健身项目': 'menu.fitnessProject',
        '付款管理': 'menu.paymentMgmt',
        '散客付款': 'menu.casualPayment',
        '散客预约支付记录': 'menu.casualBookingPaymentRecord',
        '线上到店付款': 'menu.onlineOfflinePayment',
        '线上未付款记录': 'menu.onlineUnpaidRecord',
        '线上付款记录': 'menu.onlinePaidRecord',
        '消息管理': 'menu.messageMgmt',
        '项目分类管理': 'menu.projectCategoryMgmt',
        '项目分类': 'menu.projectCategory',
        '升级管理': 'menu.upgradeMgmt',
        '升级类型设置': 'menu.upgradeTypeSettings',
        '升级添加': 'menu.upgradeAdd',
        '升级订单列表': 'menu.upgradeOrderList',
        '系统管理': 'menu.systemMgmt',
        '轮播图管理': 'menu.bannerMgmt',
        '主页管理': 'menu.systemSettings',
        '健身资讯': 'menu.fitnessNews',
        '充值促销管理': 'menu.rechargePromotionMgmt',
        '用户充值': 'menu.userRecharge',
        '充值记录': 'menu.rechargeRecord',
        '充值规则': 'menu.rechargeRules',
        'VIP管理': 'menu.vipMgmt',
        'VIP购买': 'menu.vipPurchase',
        'VIP记录': 'menu.vipRecord',
        'GiftCard管理': 'menu.giftCardMgmt',
        'GiftCard生成': 'menu.giftCardGeneration',
        'GiftCard购买': 'menu.giftCardPurchase',
        'GiftCard记录': 'menu.giftCardRecord',
        '退款管理': 'menu.refundMgmt',
        '退款处理': 'menu.refundProcessing',
        '场控管理': 'menu.venueControlMgmt',
        '房间管理': 'menu.roomMgmt',
        '房间日历': 'menu.roomCalendar',
        '清洁计划': 'menu.cleaningPlan',
        '店铺管理': 'menu.shopMgmt',
        '店铺': 'menu.shop',
        '店铺教练管理': 'menu.shopCoachMgmt',
        '店铺教练绑定': 'menu.shopCoachBinding',
        '文档中心': 'menu.documentCenter',
        '文档管理': 'menu.documentMgmt',
        '教练文档管理': 'menu.coachDocumentMgmt',
        '教练自动添加空闲时间模式设置': 'menu.coachAutoFreeTimeMgmt',
        '教练空闲时间模式': 'menu.coachFreeTimeMode',
        '统计': 'menu.statistics',
        'member分析': 'menu.memberAnalysis',
        '分析中心': 'menu.analysisCenter',
        '教练信息管理': 'menu.coachInfoMgmt',
        '教练信息': 'menu.coachInfo',
        '教练空闲时间': 'menu.coachFreeTime',
        '空闲时间': 'menu.freeTime',
        '添加空闲时间': 'menu.addFreeTime',
        '健身项目模块': 'menu.fitnessProjectModule',
        '健身项目列表': 'menu.fitnessProjectList',
        '教练信息模块': 'menu.coachInfoModule',
        '教练信息列表': 'menu.coachInfoList',
        '门店管理': 'menu.storeMgmt',
        '管理员管理': 'menu.adminMgmt',
        '商品出入库': 'menu.product',
         '出入库记录' : 'menu.inOutRecord',
          '库存盘点' : 'menu.stocktaking',
           '销售记录' : 'menu.salesRecord',
           '库存管理' : 'menu.inventoryMgmt',
            '提成规则' : 'menu.commissionRules',
           '员工销售商品提成记录' : 'menu.staffSalesCommissionRecord',
           '员工提成管理' : 'menu.staffCommissionMgmt',
      }
      
      const translationKey = menuMap[menuName]
      return translationKey ? this.$t(translationKey) : menuName
    },
   // 判断菜单是否禁用
  isMenuDisabled(menuName) {
    // const disabledMenus = ['VIP用户', '付款管理', '线上付款记录','线上未付款记录','散客付款','散客预约支付记录','消息管理','项目分类','出入库记录','库存盘点','销售记录','商品出入库','提成规则','员工销售商品提成记录','健身资讯','member分析','分析中心','教练自动添加空闲时间模式设置','文档管理','店铺教练管理','店铺管理','场控管理','退款管理','GiftCard管理','VIP管理','充值促销管理','']
        const disabledMenus = []
    return disabledMenus.includes(menuName)
  },
  // 处理菜单点击
  handleMenuClick(child) {
    if (this.isMenuDisabled(child.menu)) {
      this.$message.warning('该功能暂未开放')
      return false
    }
    this.$router.push('/' + child.tableName)
  }
  }
}
</script>
<style lang="scss" scoped>
.index-aside {
  background-color: #e9f8ff;
  min-height: calc(100vh - 62px);
  border-right: 1px solid #ebeef5;
  padding-top: 67px;
  font-family: sans-serif;
  .menu-disabled {
  opacity: 0.5;
  cursor: not-allowed !important;
  pointer-events: none;
}

  .el-menu{
      background-color: transparent

  }

  .el-submenu {
    &__title {
      &:hover {
        background-color: transparent !important;
        color: #06b0a8 !important;
        i {
          color: #06b0a8 !important;
        }
        span {
          color: #06b0a8 !important;
        }
      }
    }
  }
  .index-aside-inner {
    height: 100%;
    overflow-y: auto;
    box-sizing: border-box;
  }

  .menulist-item {
    padding: 0;
   
  }
 .el-menu-item {
      // 移除或修改背景颜色
      &:hover {
        background-color: transparent !important;
        color: #06b0a8 !important;
         i{
       
        background-color: transparent !important;
        color: #06b0a8 !important;
      
      }
      }
     
    }
 
  .el-menu-vertical-demo {
    border-right: none;
 
  }
}
</style>
